import {useAtom} from 'jotai';
import {Fragment, useRef, useState} from 'react';
import toast from '@/components/HotToast';
import {MenuItem} from '@/components/Menu';
import {useBackgroundClick} from '@/hooks';
import {useGA4WithParams} from '@/hooks/tracking';
import {analysisDrawItemAtom} from '@/map/atom';
import {MAX_VISIBLE_ZOOM_METER, MESSAGES} from '@/map/constants';
import {AreaOverlayType} from '@/map/enums';
import {useVisibleZoomLevel} from '@/map/hooks';
import {Divider, PaddingBox} from '@/styled-components';
import {getIntlString} from '@/utils';
import Icon from './assets/icon-analysis.svg';
import {Menu} from './Menu';
import {ButtonContainer, Dropdown} from './StyledComponents';

const getErrorMessage = (
  key: string,
  variables?:
    | {
        [key: string]: string;
      }
    | undefined
) => getIntlString(MESSAGES, key, variables);

const LABEL = {
  [AreaOverlayType.CIRCLE]: '반경',
  [AreaOverlayType.POLYGON]: '다각형',
  [AreaOverlayType.EMD]: '단일 행정동',
};

export const AnalysisMenu = () => {
  const [open, setOpen] = useState<boolean>();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLDivElement>(null);
  const isVisibleLevel = useVisibleZoomLevel(MAX_VISIBLE_ZOOM_METER.anaysis);

  const [drawItem, setDrawItem] = useAtom(analysisDrawItemAtom);
  const activeType = drawItem?.type;

  const tracking = useGA4WithParams();

  useBackgroundClick(
    dropdownRef,
    () => {
      setOpen(false);
    },
    [buttonRef]
  );

  const onClick = (type: AreaOverlayType) => {
    if (type !== activeType) {
      if (!isVisibleLevel) {
        return toast(
          getErrorMessage('area-analytics-zoom-warning', {
            type: `${LABEL[type]} 분석을`,
          })
        );
      }

      // 고정 반경인 경우
      // setDrawItem({
      //   type,
      //   [type]: {
      //     radius: 500,
      //   },
      // });

      setDrawItem({type});
      setOpen(false);
      tracking(`analyisis_${type}_quickmenu`);
    } else {
      setDrawItem(null);
    }
  };

  const menu = Object.entries(LABEL);

  return (
    <ButtonContainer>
      <Menu
        ref={buttonRef}
        icon={Icon}
        label="상권 분석"
        active={open}
        onClick={() => setOpen((prev) => !prev)}
      />
      {open && (
        <Dropdown ref={dropdownRef}>
          {menu.map(([type, label], idx) => (
            <Fragment key={type}>
              <MenuItem
                size="small"
                onClick={() => onClick(type as AreaOverlayType)}
              >
                {label}
              </MenuItem>
              {idx < menu.length - 1 && (
                <PaddingBox left={8} right={8}>
                  <Divider />
                </PaddingBox>
              )}
            </Fragment>
          ))}
        </Dropdown>
      )}
    </ButtonContainer>
  );
};
